import React from "react";
import { Alert, Button, Card, Col, Row, Typography, Upload } from "antd";
import { CloudUploadOutlined, FileExcelOutlined, InboxOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import ExcelExport from "components/shared-components/ExcelExport";
import { getPriceImportTemplateExcelData } from "functions/excel";
import { COMPANY_CONSTANTS } from "constants/CompanyConstants";
import { DATE_FORMAT_DD_MM_YYYY } from "constants/DateConstant";

const { Paragraph, Text, Title } = Typography;

const UploadStep = ({ products, onFileSelected, isReading, fileError }) => {
  const { t } = useTranslation();

  const uploadProps = {
    name: "file",
    multiple: false,
    accept: ".xlsx,.xls,.csv",
    showUploadList: false,
    // We uploaden niets naar een server: het bestand wordt in de browser gelezen.
    beforeUpload: (file) => {
      onFileSelected(file);
      return Upload.LIST_IGNORE;
    },
  };

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} lg={14}>
        <Card>
          <Upload.Dragger {...uploadProps} disabled={isReading}>
            <p className="ant-upload-drag-icon">{isReading ? <CloudUploadOutlined /> : <InboxOutlined />}</p>
            <p className="ant-upload-text">
              {isReading ? t("price_import.upload.reading") : t("price_import.upload.dragger_title")}
            </p>
            <p className="ant-upload-hint">{t("price_import.upload.dragger_hint")}</p>
          </Upload.Dragger>

          {!!fileError && <Alert style={{ marginTop: 16 }} type="error" showIcon message={fileError} />}
        </Card>
      </Col>

      <Col xs={24} lg={10}>
        <Card>
          <Title level={5} style={{ marginBottom: 12 }}>
            {t("price_import.upload.how_it_works_title")}
          </Title>
          <ul style={{ paddingLeft: 18, marginBottom: 20 }}>
            {["step_columns", "step_match", "step_price", "step_review"].map((key) => (
              <li key={key} style={{ marginBottom: 6 }}>
                <Text type="secondary">{t(`price_import.upload.${key}`)}</Text>
              </li>
            ))}
          </ul>

          <Paragraph type="secondary" style={{ marginBottom: 12 }}>
            {t("price_import.upload.template_description")}
          </Paragraph>
          <ExcelExport
            data={getPriceImportTemplateExcelData(products)}
            fileName={`${COMPANY_CONSTANTS.WEBSITE_NAME} prijzen ${dayjs().format(DATE_FORMAT_DD_MM_YYYY)}`}
          >
            <Button icon={<FileExcelOutlined />} disabled={!products || products.length === 0} block>
              {t("price_import.upload.template_button")}
            </Button>
          </ExcelExport>
        </Card>
      </Col>
    </Row>
  );
};

export default UploadStep;
